import { render, staticRenderFns } from "./DontMeetRequirements.vue?vue&type=template&id=48571180&"
import script from "./DontMeetRequirements.vue?vue&type=script&lang=js&"
export * from "./DontMeetRequirements.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports